import React from "react";
import {
  PdfIcon,
  PptIcon,
  DocIcon,
  ImageIcon,
  TxtIcon,
  XlsIcon,
} from "../assets/icons";

/**
 * Returns an icon component for a given file. For now, always returns PdfIcon.
 * Later, map by MIME type or extension to specific icons.
 */
export function getFileIcon(
  file?: { type?: string; name?: string },
  props?: { width?: string; height?: string; className?: string }
): React.ReactNode {
  const {
    width = "100%",
    height = "100%",
    className = "cx-text-brand-primary-regular",
  } = props || {};

  const name = (file?.name || "").toLowerCase();
  const ext = name.split(".").pop() || "";

  switch (ext) {
    case "txt":
      return <TxtIcon width={width} height={height} className={className} />;
    case "png":
    case "jpg":
    case "jpeg":
    case "pjpec":
    case "heic":
    case "gif":
      return <ImageIcon width={width} height={height} className={className} />;
    case "doc":
    case "docx":
      return <DocIcon width={width} height={height} className={className} />;
    case "ppt":
    case "pptx":
      return <PptIcon width={width} height={height} className={className} />;
    case "xls":
    case "xlsx":
      return <XlsIcon width={width} height={height} className={className} />;
    default:
      return <PdfIcon width={width} height={height} className={className} />;
  }
}
